import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router, ActivatedRoute } from '@angular/router';
import { RecoverDialogComponent } from './recover-dialog/recover-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../services/auth.service';
import { LoginRequest } from '../models/login-request.model';
import { LoaderService } from '../../../shared/services/loader.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RegisterService } from '../services/register.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  hide = true;
  isTenantMode = true;
  uuidClient: number = 0;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private authService: AuthService,
    private loader: LoaderService,
    private snackBar: MatSnackBar,
    private registerService: RegisterService
  ) {}

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });

    // Detectar si viene de tenant
    this.isTenantMode = !!this.route.snapshot.params['tenant'];
  }

  onSubmit(): void {
    if (this.loginForm.invalid) return;
    this.loader.show();

    const loginPayload: LoginRequest = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia',
      },
      petition: {
        username: this.loginForm.value.email,
        password: this.loginForm.value.password,
      },
    };
    console.log(loginPayload);

    this.authService.postLogin(loginPayload).subscribe({
      next: (response) => {
        console.log('Login exitoso:', response);
        console.log('Token guardado:', localStorage.getItem('accessToken'));
        this.loader.hide();
        // this.loadProducts();
        setTimeout(() => {
          this.router.navigate(['/home']);
        }, 100);
      },
      error: (err) => {
        console.error('Error en login:', err);
        this.loader.hide();
        this.snackBar.open(
          'Credenciales inválidas. Por favor verifica tu correo y contraseña.',
          'Cerrar',
          {
            duration: 4000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['bg-red-600', 'text-white'],
          }
        );
      },
    });
  }

  goToRegister(): void {
    this.router.navigate(['/registro']);
  }

  openForgotPasswordDialog(): void {
    this.dialog.open(RecoverDialogComponent, {
      width: '500px',
      hasBackdrop: true,
      disableClose: false,
      panelClass: 'custom-dialog-container',
    });
  }

  loadProducts(): void {
    this.registerService.getProducts().subscribe({
      next: (response) => {
        if (response.success && response.data) {
          const account = localStorage.getItem('account') || '0';
          const productByAccount = response.data.find(
            (product) => product.product === account
          );
          localStorage.setItem(
            'ProductByAccount',
            JSON.stringify(productByAccount)
          );
        }
      },
      error: (err) => {
        console.error('Error loading products:', err);
      },
    });
  }
}
